<template>
  <div class="activity-pk">
    <el-card class="activity__card">
      <div class="activity-pk__title">
        PK活动配置
      </div>
      <div class="round-btn-group">
        <el-select v-model="eventCode" placeholder="请选择PK活动" style="margin-right: 10px;">
          <el-option :label="item.name" :value="item.value" v-for="item in pkActivityList" :key="item.value"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" @click="addRoundHandle">创建轮次</el-button>
        <el-button icon="el-icon-circle-plus-outline" type="success" @click="addBatchRoundHandle">批量创建轮次</el-button>
      </div>
      <div class="round-tabs-box">
        <el-tabs v-model="activeRoundCode" type="border-card" tab-position="left">
          <el-tab-pane v-for="item in pkRoundList" :label="item.name" :name="'' + item.id" :key="item.id">
            <div class="session-btn-group">
              <div>
                <el-button type="danger" icon="el-icon-delete" @click="delRoundHandle">删除该轮次</el-button>
                <el-button type="info" icon="el-icon-edit" @click="editRoundHandle">编辑该轮次</el-button>
              </div>
            </div>
            <pk-session-table v-if="Number(item.id) === Number(activeRoundCode)"
              :roundId="item.id + ''"></pk-session-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>


    <!-- 添加/修改轮次弹窗 -->
    <el-dialog title="添加轮次" :visible.sync="roundDialogData.visible" width="30%">
      <el-form :model="roundDialogData.data" label-width="80px" mode="left">
        <el-form-item label="轮次名称">
          <el-input v-model="roundDialogData.data.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="轮次介绍">
          <el-input v-model="roundDialogData.data.roundDesc" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="roundDialogData.data.orderId" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roundDialogData.visible = false">取 消</el-button>
        <el-button type="primary" @click="roundSubmitHandle">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getPkRound, setPkRound, delPkRound, addPkRound, addPkRoundAll, getActivityCode } from '@/api/pkRequest'
import pkSessionTable from '../../components/pk/pk-session-table.vue'
export default {
  components: {
    pkSessionTable
  },
  data() {
    return {
      // pk活动列表
      pkActivityList: [],
      // 活动事件码
      eventCode: null,
      // 响应轮次code
      activeRoundCode: null,
      // pk轮次列表
      pkRoundList: [],
      roundDialogData: {
        title: '添加轮次',
        visible: false,
        isEdit: false,
        data: {
          id: null,
          name: '',
          roundDesc: '',
          orderId: null,
          operator: null
        }
      }
    }
  },
  watch: {
    eventCode() {
      this.getPkRoundList()
    },
    activeRoundCode(value) {
    }
  },
  methods: {
    reqMessageShow(res) {
      if (res.code === 0) {
        this.$message({ type: 'success', message: "操作成功" })
        this.getPkRoundList()
      } else {
        this.$message({ type: 'warning', message: res.msg })
      }
    },
    // 后端拉取轮次列表
    async getPkRoundList() {
      const res = await getPkRound({ eventCode: this.eventCode })
      if (res.code === 0) {
        this.pkRoundList = res.data
      } else {
        this.$message({
          type: 'warning',
          message: res.msg
        })
      }
    },
    async roundSubmitHandle() {
      let res = null
      if (this.roundDialogData.isEdit) {
        res = await setPkRound(this.roundDialogData.data)
      } else {
        res = await addPkRound({
          name: this.roundDialogData.data.name,
          roundDesc: this.roundDialogData.data.roundDesc,
          orderId: this.roundDialogData.data.orderId,
          eventCode: this.eventCode
        })

      }
      this.roundDialogData.visible = false
      this.reqMessageShow(res)

    },
    // 添加轮次按钮
    addRoundHandle() {
      this.roundDialogData.title = '添加轮次'

      this.roundDialogData.isEdit = false
      this.roundDialogData.visible = true
      this.roundDialogData.data = {
        id: null,
        name: '',
        roundDesc: '',
        orderId: null,
      }
    },
    // 编辑轮次按钮
    editRoundHandle() {
      this.roundDialogData.title = '编辑轮次'
      this.roundDialogData.isEdit = true
      this.roundDialogData.visible = true
      const curRoundData = this.pkRoundList.find(item => item.id === Number(this.activeRoundCode))
      this.roundDialogData.data = {
        id: curRoundData.id,
        name: curRoundData.name,
        roundDesc: curRoundData.roundDesc,
        orderId: curRoundData.orderId,
      }
    },
    // 删除某一轮次
    async delRoundHandle() {
      try {
        await this.$confirm('此操作将永久删除该轮次, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await delPkRound({ id: Number(this.activeRoundCode) })
        this.reqMessageShow(res)
      } catch (error) {
        console.log(error);
      }
    },
    async addBatchRoundHandle() {
      try {
        const { value } = await this.$prompt('请输入轮次', '批量创建轮次', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[1-9]\d*$/,
          inputErrorMessage: '必须是正整数'
        })
        const res = await addPkRoundAll({ num: value, eventCode: this.eventCode })
        this.reqMessageShow(res)
        // 调用批量创建接口
      } catch (error) {

      }
    },




  },
  async mounted() {
    const res = await getActivityCode()
    this.pkActivityList = res.data
    this.eventCode = this.pkActivityList[0].value
  }
}
</script>

<style scoped lang ="scss">
.activity-pk {
  &__card {
    margin: 0 20px;
    padding: 20px 10px;
  }

  &__title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 26px;
  }
}

.round-btn-group {
  margin-bottom: 26px;
}

.session-btn-group {
  margin-bottom: 26px;
  display: flex;
  justify-content: space-between;
}

.round-tabs-box {
  height: 680px;
  margin-bottom: 26px;

  .el-tabs {
    height: 680px;

  }
}
</style>
